import _ from 'underscore'
import React from 'react'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import DateComponent from '../date'
import store from '../../state/store'

class RelatedResourcesPartial extends React.Component {

  onClick = (e) => {
    e.preventDefault()
    const resource = this.props.related_resource

    if (resource.type == 'Enquiry') {
      store.emit('enquiries:show', resource.id)
    }
    else if (resource.type == 'Lead') {
      store.emit('leads:show', resource.id)
    }
  }

  render() {
    const resource = this.props.related_resource
    let status = resource.status

    if (resource.manager) {
      status += ` by ${resource.manager.name}`
    }

    return (
      <DropdownMenuItem key={resource.id} data-enquiry-id={resource.id} onSelect={this.onClick} className="flex items-start gap-3">
        {!_.isEmpty(resource.created_at) ?
          <span className="shrink-0 whitespace-nowrap text-xs tabular-nums text-muted-foreground">
            <DateComponent date={resource.created_at} />
          </span>
          : null
        }
        <span className="min-w-0 flex-1 text-sm">{resource.type} {resource.id} {status}</span>
      </DropdownMenuItem>
    )
  }
}

export default RelatedResourcesPartial
